import {observable, action, runInAction} from 'mobx'
import {get, json} from '../../../utils/ajax'
import {handleSearchAndPage, setStore, ValueObjToObj} from '../../../utils/Utils'
import moment from "moment/moment";
import {message} from "antd/lib/index";

class knowledgeBaseStore {
    @observable loading  //列表loading
    @observable searchField    //搜索表单绑值
    @observable pagination //列表分页
    @observable knowledgeBaseList  //列表数据
    @observable multipleSelectedRows  //批量删除
    @observable exportModal  //导入模态框显示属性
    @observable  uploadAddress  //保存上传地址
    @observable  uploadName//保存上传名称
    @observable  uploading//保存上传loading
    @observable  modelStatus


    constructor() {
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.knowledgeBaseList = []
        this.searchField = {
            endTime: '',
            startTime: '',
            uploadName: '',
            rangePicker:[]
        }
        this.multipleSelectedRows = []
        this.exportModal = false
        this.uploadAddress = ''
        this.uploadName = ''
        this.uploading=false
        this.modelStatus=false
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /*** 主页面请求接口加载数据**/
    @action
    initPage = async (page) => {
        this.loading = true
        let searchField = {
            uploadName: this.searchField.uploadName ? this.searchField.uploadName : '',
            startTime: this.searchField.rangePicker.length>0 ? moment(this.searchField.rangePicker[0]).format("YYYY-MM-DD") : '',
            endTime: this.searchField.rangePicker.length>0  ? moment(this.searchField.rangePicker[1]).format("YYYY-MM-DD") : ''
        }
        let search = handleSearchAndPage(page, this.pagination, searchField)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/knowledgeBaseManagement/getKnowledgeBasePage:search`, search)
        runInAction(() => {
            this.knowledgeBaseList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }


    /***更新下载次数**/
    @action
    postDownLoad = async (id) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/knowledgeBaseManagement/updateDownloadCount?id=${id}`)
    }


    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields) => {
        this.searchField = {...this.searchField, ...ValueObjToObj(changedFields)}
    }


    /*** 清空搜索框*/
    @action
    clearForm = () => {
        this.searchField = {
            endTime: '',
            startTime: '',
            uploadName: '',
            rangePicker:[]
        }
        this.initPage()
    }

    /**删除多条**/
    @action
    multipleDelete = async (ids) => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/knowledgeBaseManagement/deleteByIds`, ids)
        runInAction(() => {
            this.loading = false
        })
        message.success('删除成功')
        this.initPage(this.pagination)
    }

    /**发送导入请求***/
    @action
    addUpFile = async () => {
        let upFile = {
            uploadAddress: this.uploadAddress,
            uploadName: this.uploadName
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/knowledgeBaseManagement/addFile`, upFile)
    }
}

export default new knowledgeBaseStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/KnowledgeBase/store.js